import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageBreadcrumbComponent } from '../../../shared/components/common/page-breadcrumb/page-breadcrumb.component';
import { BadgeComponent } from '../../../shared/components/ui/badge/badge.component';
import { LeadDisqualificationReasonApiService } from '../services/lead-disqualification-reason-api.service';
import { LeadDisqualificationReasonResponse } from '../models/lead-disqualification-reason.model';
import { AuthService } from '../../auth-pages/services/auth.service';
import { ConfirmDialogService } from '../../../shared/services/confirm-dialog.service';
import { ToastService } from '../../../shared/services/toast.service';
import { HasPermissionDirective } from '../../../shared/directives/has-permission.directive';

type BadgeColor = 'primary' | 'success' | 'error' | 'warning' | 'info' | 'light' | 'dark';

@Component({
  selector: 'app-lead-disqualification-reason-list',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    PageBreadcrumbComponent,
    BadgeComponent,
    HasPermissionDirective
  ],
  templateUrl: './lead-disqualification-reason-list.component.html'
})
export class LeadDisqualificationReasonListComponent implements OnInit {
  razones: LeadDisqualificationReasonResponse[] = [];
  loading = false;
  error = '';

  constructor(
    private reasonApi: LeadDisqualificationReasonApiService,
    private authService: AuthService,
    private router: Router,
    private confirmDialog: ConfirmDialogService,
    private toast: ToastService
  ) { }

  ngOnInit(): void {
    this.cargarRazones();
  }

  cargarRazones(): void {
    this.loading = true;
    this.error = '';

    const user = this.authService.getCurrentUser();
    const businessId = user?.businessId || 1;

    this.reasonApi.getReasons(businessId).subscribe({
      next: (data) => {
        this.razones = data;
        this.loading = false;
      },
      error: (err) => {
        this.error = err.error?.message || 'Error al cargar las razones de descalificación';
        this.loading = false;
        console.error('Error:', err);
      }
    });
  }

  nuevaRazon(): void {
    this.router.navigate(['/config-leads/razones-descalificacion/crear']);
  }

  editarRazon(razon: LeadDisqualificationReasonResponse): void {
    this.router.navigate(['/config-leads/razones-descalificacion/editar', razon.id]);
  }

  async eliminarRazon(razon: LeadDisqualificationReasonResponse): Promise<void> {
    const ok = await this.confirmDialog.confirmDanger({
      title: 'Eliminar razón',
      message: `¿Está seguro de eliminar la razón "${razon.name}"?`
    });
    if (!ok) return;
    const user = this.authService.getCurrentUser();
    const businessId = user?.businessId || 1;

    this.reasonApi.deleteReason(razon.id, businessId).subscribe({
      next: () => {
        this.cargarRazones();
        this.toast.deleted('Razón de descalificación', `Se eliminó "${razon.name}" correctamente.`);
      },
      error: (err) => {
        this.toast.error({ title: 'Error', message: err.error?.message || 'Error al eliminar la razón' });
      }
    });
  }

  getActiveColor(isActive: boolean): BadgeColor {
    return isActive ? 'success' : 'error';
  }

  getActiveLabel(isActive: boolean): string {
    return isActive ? 'Activo' : 'Inactivo';
  }

  getAutoRescheduleColor(autoReschedule: boolean): BadgeColor {
    return autoReschedule ? 'info' : 'light';
  }

  getAutoRescheduleLabel(autoReschedule: boolean): string {
    return autoReschedule ? 'Si' : 'No';
  }
}
